import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { WithNotFound } from '../errors';
import { ReportList } from './reportList';
import { SettlementList } from './settlementList';

const ReportsRoutes = () => (
    <WithNotFound>
        <Route
            exact
            path="/:accountId/reports"
            render={(props) => <Redirect to={`/${props.match.params.accountId}/reports/reports`} />}
        />
        <Route path={`/:accountId/reports/reports`} component={ReportList} />
        <Route path={`/:accountId/reports/settlements`} component={SettlementList} />
    </WithNotFound>
);

export default ReportsRoutes;
